export default __webpack_public_path__ + "static/media/ceramol-acn3-products-360.6afece36.jpg";